import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import api from '../api';

function UserProfile() {
  const { user } = useSelector((state) => state.auth);
  const [profile, setProfile] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    bio: '',
    phone: '',
    address: '',
    city: '',
    country: ''
  });
  const [saving, setSaving] = useState(false);
  
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await api.get('/users/me');
        setProfile(response.data.data);
        if (response.data.data) {
          setFormData({
            firstName: response.data.data.firstName || '',
            lastName: response.data.data.lastName || '',
            bio: response.data.data.bio || '',
            phone: response.data.data.phone || '',
            address: response.data.data.address?.street || '',
            city: response.data.data.address?.city || '',
            country: response.data.data.address?.country || ''
          });
        }
      } catch (error) {
        console.error('Failed to fetch profile:', error);
      }
    };
    fetchProfile();
  }, []);

  // Polling for real-time profile updates
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await api.get('/users/me');
        setProfile(response.data.data);
        if (response.data.data) {
          setFormData({
            firstName: response.data.data.firstName || '',
            lastName: response.data.data.lastName || '',
            bio: response.data.data.bio || '',
            phone: response.data.data.phone || '',
            address: response.data.data.address?.street || '',
            city: response.data.data.address?.city || '',
            country: response.data.data.address?.country || ''
          });
        }
      } catch (error) {
        console.error('Failed to fetch profile:', error);
      }
    };

    const pollProfile = setInterval(fetchProfile, 30000); // 30 seconds

    return () => {
      clearInterval(pollProfile);
    };
  }, []);
  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await api.put('/users/profile', formData);
      setProfile(response.data.data);
    } catch (error) {
      console.error('Failed to update profile:', error);
    }
    setSaving(false);
  };
  
  return (
    <div className="user-profile">
      <h1>My Profile</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>First Name</label>
            <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Last Name</label>
            <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
          </div>
        </div>
        <div className="form-group">
          <label>Bio</label>
          <textarea name="bio" value={formData.bio} onChange={handleChange} rows={4} />
        </div>
        <div className="form-group">
          <label>Phone</label>
          <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label>Address</label>
          <input type="text" name="address" value={formData.address} onChange={handleChange} />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>City</label>
            <input type="text" name="city" value={formData.city} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Country</label>
            <input type="text" name="country" value={formData.country} onChange={handleChange} />
          </div>
        </div>
        <button type="submit" disabled={saving}>
          {saving ? 'Saving...' : 'Save Profile'}
        </button>
      </form>
    </div>
  );
}

export default UserProfile;